import AxiosNode from '@/services/api/node/axios_node'

export default {
  getActions: (params) => {
    return AxiosNode.get('/action', { params })
  },

  createAction: (data) => {
    return AxiosNode.post('/action', data)
  },

  updateAction: (data, id) => {
    return AxiosNode.put(`/action/${id}`, data)
  },

  deleteAction: (id) => {
    return AxiosNode.delete(`/action/${id}`)
  },

  getNodeData: (nodeId) => {
    return AxiosNode.get('/node/' + nodeId)
  }
}
